import { action } from 'mobx';
import { UserPasswordChangeForm } from 'modules/user/forms';
import { BaseViewStore } from 'core/stores';
import { formInvalidate } from 'core/utils';

class UserPasswordChangeViewStore extends BaseViewStore {
	user;

	form = new UserPasswordChangeForm({
		onSuccess: async () => {
			if (this.user.isApproved) {
				await this.changeUserPassword();
			} else {
				this.rootStore.notificationStore.error('PASSWORDCHANGEFAIL');
			}
		},
	});

	constructor(rootStore) {
		super(rootStore);
		this.parentView = rootStore.userListViewStore;
		this.listStore = rootStore.userListViewStore.listStore;
		this.initialize();
	}

	@action async initialize() {
		this.form.reset();

		await this.getUser(this.rootStore.routerStore.routerState.queryParams.changePassword_id);
		this.user = this.listStore.item;
	}

	@action async getUser(id) {
		await this.listStore.getUser(id);
	}

	@action.bound async changeUserPassword() {
		const { newPassword } = this.form.values();
		if (newPassword.toLowerCase().includes(this.user.userName.split('-')[0].toLowerCase())) {
			this.form.invalidate('PASSWORDCONTAINSUNSERNAME');
		} else {
			this.suspend();
			try {
				await this.listStore.changeUserPassword(this.user.userName, this.form.values());
				this.rootStore.notificationStore.success(['PASSWORDCHANGECONFIRM', { user: this.user.userName.split('-')[0] }]);
				await this.parentView.findUsers();
				this.parentView.closeModal();
			} catch (err) {
				formInvalidate({ form: this.form, err });
			}
			this.resume();
		}
	}
}

export default UserPasswordChangeViewStore;
